import { Upload } from "lucide-react";
import React from "react";
import { type FileWithPath, useDropzone } from "react-dropzone";

type UploadDropzoneProps = {
  disabled?: boolean;
  onFilesDropped: (files: FileWithPath[]) => void;
  children: React.ReactNode;
  overlayTitle?: string;
  overlayDescription?: string;
  multiple?: boolean;
  accept?: Record<string, string[]>;
  noDragEventsBubbling?: boolean;
};

export default function UploadDropzone({
  disabled = false,
  onFilesDropped,
  children,
  overlayTitle = "Drop files here to upload",
  overlayDescription = "Files will be uploaded to the workspace",
  multiple = true,
  accept,
  noDragEventsBubbling = false,
}: UploadDropzoneProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onFilesDropped,
    noClick: true,
    noKeyboard: true,
    multiple,
    disabled,
    accept,
    noDragEventsBubbling,
  });

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <div {...getRootProps()} className="contents">
      <input {...getInputProps()} />
      {children}
      {isDragActive && (
        <div className="bg-background/10 supports-[backdrop-filter]:bg-background/5 border-primary pointer-events-none fixed inset-5 z-50 flex items-center justify-center rounded-lg border-3 border-dashed backdrop-blur-sm">
          <div className="text-primary flex flex-col items-center gap-6 rounded-xl p-12">
            <Upload className="size-16" />
            <div className="text-center">
              <div className="text-xl font-medium">{overlayTitle}</div>
              <div className="text-muted-foreground text-base">{overlayDescription}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
